import { joiResolver } from '@hookform/resolvers/joi';
import { AxiosError } from 'axios';
import { useForm, UseFormReturn } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import {
  ChangePasswordRequest,
  ChangePasswordResponse,
  usePutChangePassword,
} from '../../../api-refactored/auth/usePutChangePassword';
import { UseCustomMutationReturn } from '../../../api-refactored/utils/useCustomMutation';
import { UpdatePasswordForm } from '../../../models';
import { LocationState } from '../../../models/Location';
import updatePasswordSchema from '../schema/updatePasswordSchema';
import { useAuth } from './auth';

interface UpdatePasswordReturn {
  /**
   * Perform submit action, either to call block call or unblock call, depends on the account status
   */

  /**
   * Form to send edit & delete
   */

  formHook: UseFormReturn<UpdatePasswordForm>;
  handleUpdatePassword: (formData: UpdatePasswordForm) => void;
  putChangePasswordMutation: UseCustomMutationReturn<
    ChangePasswordResponse,
    AxiosError<any>,
    ChangePasswordRequest,
    unknown
  >;
  /**
   * React query mutation object
   */
}

/**
 * A hook to handle search functionality
 * @returns
 */

export const useUpdatePassword = (): UpdatePasswordReturn => {
  const auth = useAuth();
  const location = useLocation<LocationState>();
  const history = useHistory();
  const { from } = location?.state || { from: { pathname: '/', search: '?', message: null } };

  const formHook = useForm<UpdatePasswordForm>({
    mode: 'onSubmit',
    resolver: joiResolver(updatePasswordSchema),
  });

  const putChangePasswordMutation = usePutChangePassword({
    onSuccess: () => {
      auth.signin(() => {
        history.replace(`${from.pathname}${from.search}`, {
          from: { pathname: location.pathname },
        });
      });
    },
  });

  const handleUpdatePassword = (formData: UpdatePasswordForm) => {
    putChangePasswordMutation.mutate({
      confirmedPassword: formData.confirmNewPassword,
      newPassword: formData.newPassword,
      oldPassword: formData.oldPassword,
    });
  };

  return {
    formHook,
    handleUpdatePassword,
    putChangePasswordMutation,
  };
};
